import { Colors, Fonts } from '../../../../../../shared/theme';
import { textStyles } from '../../../../../../shared/theme/fonts-ppv';

export default {
  mapPreviewBox: {
    maxWidth: 500,
    aspectRatio: '10 / 3',
    marginBottom: 8,
    overflow: 'hidden',
  } as React.CSSProperties,
  mapPreviewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    cursor: 'pointer',
  } as React.CSSProperties,
  mapHintBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    paddingBottom: '8px',
  } as React.CSSProperties,
  mapHintIcon: {
    color: Colors.font.primary.darkGray,
    fontSize: Fonts.size.text14,
    lineHeight: '20px',
  } as React.CSSProperties,
  mapHint: {
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray,
  } as React.CSSProperties,
  mapWarningBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '6px',
    maxWidth: 500,
    marginBottom: 8,
  } as React.CSSProperties,
  mapWarningIcon: {
    color: Colors.red600,
    fontSize: Fonts.size.text14,
    lineHeight: '20px',
    flexShrink: 0,
  } as React.CSSProperties,
  mapWarning: {
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.red600,
  } as React.CSSProperties,
  latInput: {
    flex: 1,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  } as React.CSSProperties,
  lngInput: {
    flex: 1,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  } as React.CSSProperties,
  modalSpacer: {
    height: '30px',
  } as React.CSSProperties,
  modalTitle: {
    ...textStyles.h2,
    fontSize: Fonts.size.text24,
    color: Colors.textPrimary,
  } as React.CSSProperties,
  mapLoadingElement: {
    height: '100%',
  } as React.CSSProperties,
  mapContainerElement: {
    height: '400px',
  } as React.CSSProperties,
};
